import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer');
const UnauthorizedContainer = () =>
  import('@/containers/UnauthorizedContainer');

// 404
const Page404 = () => import('@/views/pages/Page404');

// Companies
const Companies = () => import('@/views/companies/Companies');
const CompaniesCreate = () => import('@/views/companies/New');
const CompaniesView = () => import('@/views/companies/Company');

// Customers
const Customers = () => import('@/views/customers/Customers');
const CustomersCreate = () => import('@/views/customers/New');
const CustomersView = () => import('@/views/customers/Customer');

// Glossary
const Glossary = () => import('@/views/glossary/Glossary');

// Requests
const Requests = () => import('@/views/requests/Requests');
const RequestsView = () => import('@/views/requests/Request');

// Users
const Users = () => import('@/views/users/Users');
const User = () => import('@/views/users/User');
const UserCreate = () => import('@/views/users/New');

// Login
const Login = () => import('@/views/login/Login');
const PasswordForgot = () => import('@/views/login/PasswordForgot');
const PasswordReset = () => import('@/views/login/PasswordReset');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'admin',
      component: DefaultContainer,
    },
    {
      path: '/admin',
      name: 'admin',
      component: DefaultContainer,
      children: [
        {
          path: 'bedrijven',
          name: 'companies',
          component: Companies,
        },
        {
          path: 'bedrijven/toevoegen',
          name: 'companies.create',
          component: CompaniesCreate,
        },
        {
          path: 'bedrijven/:id',
          name: 'companies.view',
          component: CompaniesView,
        },
        {
          path: 'klanten',
          name: 'customers',
          component: Customers,
        },
        {
          path: 'klanten/toevoegen',
          name: 'customers.create',
          component: CustomersCreate,
        },
        {
          path: 'klanten/:id',
          name: 'customers.view',
          component: CustomersView,
        },
        {
          path: 'aanvragen',
          name: 'requests',
          component: Requests,
        },
        {
          path: 'aanvragen/:id',
          name: 'requests.view',
          component: RequestsView,
        },
        {
          path: 'glossary',
          name: 'glossary',
          component: Glossary,
        },
        {
          path: 'gebruikers',
          name: 'users',
          component: Users,
        },
        {
          path: 'gebruikers/toevoegen',
          name: 'users.create',
          component: UserCreate,
        },
        {
          path: 'gebruikers/:id',
          name: 'users.view',
          component: User,
        },
      ],
    },
    {
      path: '',
      name: 'login-main',
      redirect: '/login',
      component: UnauthorizedContainer,
      children: [
        {
          path: 'login',
          name: 'login',
          component: Login,
        },
        {
          path: 'forgot-password',
          name: 'forgot-password',
          component: PasswordForgot,
        },
        {
          path: 'reset-password',
          name: 'reset-password',
          component: PasswordReset,
        },
      ],
    },
    {
      path: '*',
      component: Page404,
    },
  ],
});

router.beforeEach((to, from, next) => {
  store.dispatch('fetchAccessToken');
  if (to.fullPath.includes('admin')) {
    if (!store.state.accessToken) {
      next('/login');
    }
  }
  if (to.fullPath === '/login') {
    if (store.state.accessToken) {
      next('/admin');
    }
  }
  next();
});

export default router;
